module.exports = __webpack_public_path__ + "img/img12.3273670d.svg";